<tiime-dialog [isLoading]="isLoading()" (cancel)="cancel()">
  <span mat-dialog-title data-cy="send-to-lya-dialog-title">Envoyer le dossier sur Lya</span>
  <mat-dialog-content class="dialog-content send-to-lya-dialog-content" mat-dialog-content>
    <span class="message">{{ message() }}</span>
    @if (violations()?.length) {
      <tiime-alert [displayIcon]="false" warn>
        <h3>Impossible d'envoyer le dossier sur Lya</h3>
        <ul>
          @for (violation of violations(); track $index) {
            <li>{{ violation }}</li>
          }
        </ul>
      </tiime-alert>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="send-to-lya-dialog-actions">
    <button
      tiime-button
      color="accent"
      strocked
      large
      [disabled]="isLoading()"
      (click)="cancel()"
      data-cy="send-to-lya-dialog-cancel-btn"
    >
      Annuler
    </button>
    <button
      tiime-button
      color="accent"
      large
      raised
      [disabled]="isLoading()"
      (click)="sendToLya()"
      data-cy="send-to-lya-dialog-save-btn"
    >
      Envoyer
    </button>
  </mat-dialog-actions>
</tiime-dialog>
